// TipoField

import React from 'react';

function TipoField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input 
        type="text"
        placeholder="Digite o Tipo da Venda"
        style={{ width: '160px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default TipoField;